<template>
  <div>
    <main class="mt00 mb20" v-cloak>
      <h2 id="ttl-room" class="break-word">{{ room.name }}</h2>
      <p class="center bold">{{ room.nickname }}</p>
      <p v-if="room.createdAt" class="center">{{ formatDateTime(room.createdAt.toDate() , "MM-ddhhmm") }}</p>
    </main>
    <div v-if="sortedComments.length > 0" id="room-area">
      <span class="morelink link1" @click="loadMore" :hidden="hideMore">さらに読み込む</span>
      <div :class="{ 'room-box': true, 'mine': sender(message.user_id) }" v-for="message in sortedComments" :key="message.id">
        <p class="time">{{ sendDate(message.createdAt.toDate()) }}</p>
        <div class="comment-box">
          <dl class="user-name">
            <img class="user-photo" :src="image(message.photoUrl)" @error="imageErr">
            <dd>{{ message.nickname }}</dd>
          </dl>
          <p class="user-comment break-word" style="white-space:pre-line;">{{ message.message }}</p>  
        </div>
      </div>
    </div>
    <div class="comment-input">
      <p class="txt-error" v-if="!$v.comment.maxLength">
        {{ this.getMessage($v.comment, { name: "コメント" }) }}
      </p>
      <textarea placeholder="コメントを入力" v-model.trim="$v.comment.$model"></textarea>
      <button @click="send" :disabled="isEmpty(this.comment) || this.$v.$invalid">投稿</button>
    </div>
    <p class="txt-error center mb40">
      <firebaseError :error="this.fbError" :errorCode="errorCode"/>
    </p>
  </div>
</template>

<script>
import firebase from 'firebase'
import deflt from "@/assets/img/icon-account-profile.jpg"
import firebaseError from "@/error/FirebaseError"
import { maxLength } from "vuelidate/lib/validators"

export default {
  name : "Room",
  data () {
    return { 
      db : firebase.firestore(),
      roomId: null,
      room : {},
      comments: [],
      user :firebase.auth().currentUser,
      comment : "",
      nickname : "",
      fbError : false, //firebaseエラー
      errorCode: "",
      page: {
        current: null,
        limit: 5,
      },
      hideMore: true
    }
  },
  validations: {
    comment: {
      maxLength : maxLength(300),
    },
  },
  computed : {
    image () {
      return function(img) {
        this.src = null
        return img || deflt
      }
    },
    sender () {
      return function(id) {
        return this.eq(id , this.user.uid)
      }
    },
    sortedComments () {
      return this.comments.slice().sort((a, b) => {
        return (a.createdAt < b.createdAt) ? -1 : (a.createdAt > b.createdAt) ? 1 : 0
      })
    },
  },
  components: {
    firebaseError,
  },
  async created () {
    this.roomId = this.$route.params.id
    if (!this.roomId) {
      this.$router.push({ name: 'NotFound' })
      return
    }
    const ref = this.db.collection("rooms").doc(this.roomId)
    const doc = await ref.get()
    if (!doc.exists) {
      this.$router.push({ name: 'NotFound' })
      return
    }
    const data = doc.data()
    this.room = {
      id: doc.id,
      name: data.name,
      nickname: data.nickname,
      userId: data.user_id,
      createdAt: data.created_at,
    }

    // メッセージ監視
    ref.collection("messages").orderBy("created_at", "desc").limit(this.page.limit).onSnapshot((snapshot) => {
      if (!this.page.current) {
        this.page.current = snapshot.docs[snapshot.size - 1]
        this.hideMore = snapshot.size < this.page.limit
      }
      snapshot.docChanges().forEach((change) => {
        switch(change.type) {
          case("added"):
            var data = change.doc.data({ serverTimestamps: "estimate" })
            this.comments.push({
              user_id: data.user_id,
              message: data.message,
              nickname: data.nickname,
              photoUrl: data.photo_url,
              createdAt: data.created_at,
            })
            break
        }
      })
    })
  },
  mounted () {
    this.db.collection("users")
      .doc(this.user.uid)
      .get()
      .then((doc) => {
        if (doc.exists) {
          this.nickname = doc.data().nickname
        }
      })
  },
  methods: {
    async loadMore() {
      try {
      let ref = await this.db.collection("rooms").doc(this.roomId).collection("messages")
        const snapshot = await ref.orderBy("created_at", "desc").startAfter(this.page.current).limit(this.page.limit).get()
        this.page.current = snapshot.docs[snapshot.size - 1]
        this.hideMore = !this.page.current || snapshot.size < this.page.limit
        snapshot.docs.forEach((doc) => {
          var data = doc.data()
          this.comments.push({
            message: data.message,
            nickname: data.nickname,
            photoUrl: data.photo_url,
            createdAt: data.created_at,
          })
        })
      } catch (error) {
        this.$toasted.error("データの取得に失敗しました")
      }
    },
    async send () {
      try {
        this.$v.$touch()
        if(this.$v.$invalid) {
          this.vaError = true
          return
        }
        await this.db.collection("rooms").doc(this.roomId).collection("messages").add({
          message: this.comment,
          nickname: this.nickname,
          photo_url: this.user.photoURL,
          user_id: this.user.uid,
          created_at: firebase.firestore.FieldValue.serverTimestamp(),
        })
        this.db.collection("rooms").doc(this.roomId).update({
            commented_at: firebase.firestore.FieldValue.serverTimestamp(),
        })
        this.comment = ""
      } catch {
        this.$toasted.error("メッセージの投稿に失敗しました。")
      }
    },
    sendDate (date) {
      return this.formatDateTime(date , "MM-ddhhmm")
    },
    async remove (id) {
      try {
        await this.db.collection("rooms").doc(this.$route.query.id).collection("messages").doc(id).delete()
        this.$toasted.success("メッセージを削除しました。")
      } catch (error) {
        this.$toasted.error("メッセージの削除に失敗しました。")
      }
    },
    imageErr (e) {
      e.target.src = deflt
    },
  },
}
</script>

<style scoped>
[v-cloak] {
  display: none;
}
</style>